import { useMemo } from 'react';
import get from 'lodash/get';
import forEach from 'lodash/forEach';
import round from 'lodash/round';

import useSliderSettings from 'Components/Utility/SiteSlider/hooks/useSliderSettings';

/**
 * @param {Array.object} sliderSettings - Contains custom breakpoint settings for the carousel (the width of the slider & how many slides to show).
 * @param {number} totalSlides - Total number of slides in the carousel.
 * @return {String}  comma-separated list of source size descriptors followed by an optional fallback size
*/

export default function useSliderImageSrcSizes(sliderSettings = {}, totalSlides) {
  const { defaultSettings } = useSliderSettings(sliderSettings, totalSlides);

  return useMemo(() => {
    const sizes = {};

    forEach(defaultSettings, (value, key) => {
      if (key === 'xs') return;

      const sliderWidth = get(sliderSettings[key], 'sliderWidth', defaultSettings[key].sliderWidth);
      const slidesToShow = get(sliderSettings[key], 'slidesToShow', defaultSettings[key].slidesToShow);
      const sliderGap = get(sliderSettings[key], 'sliderGap', defaultSettings[key].sliderGap);

      const gaps = sliderGap * (slidesToShow - 1);
      let trackSlideWidth = round((sliderWidth - gaps) / slidesToShow);
      if (key === 'sm' || key === 'md') trackSlideWidth = round(((sliderWidth - gaps) * 0.9) / slidesToShow);

      sizes[key] = trackSlideWidth;
    });

    return (`(min-width: 1520px) ${sizes.xxl}px, (min-width: 1200px) ${sizes.xl}px, (min-width: 992px) ${sizes.lg}px, (min-width: 768px) ${sizes.md}px, (min-width: 576px) ${sizes.sm}px, 95vw`);
  }, [sliderSettings, defaultSettings]);
}
